import { render } from "./AdminCareId.vue?vue&type=template&id=0d2033b8&scoped=true"
import script from "./AdminCareId.vue?vue&type=script&lang=js"
export * from "./AdminCareId.vue?vue&type=script&lang=js"

import "./AdminCareId.vue?vue&type=style&index=0&id=0d2033b8&lang=css"
import "./AdminCareId.vue?vue&type=style&index=1&id=0d2033b8&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2033b8"]])

export default __exports__